<template>
  <div class="consultation-created">
    <success-checkmark/>

    <h2 class="title">Sua consulta está sendo processada</h2>
    <p class="description">
      Sua consulta foi criada e está sendo processa, em breve o seu resultado ficará disponível para
      que possa ser visualizado na página de consultas
    </p>
    <div class="actions">
      <button
        @click="$emit('new-query')"
        class="btn btn-primary"
        type="submit"
      >
        Nova Consulta
      </button>
      <router-link
        :to="{ name: 'Consultations-Results'}"
        class="btn btn-primary -transparent"
      >
        Ver Consultas
      </router-link>
    </div>
  </div>
</template>

<script>
import SuccessCheckmark from '@/support/components/SuccessCheckmark.vue';

export default {
  name: 'QueryCreated',

  components: {
    SuccessCheckmark,
  },
};
</script>

<style lang="scss" scoped>
  .consultation-created {
    > .title {
      @apply text-2xl;
      @apply text-center;
      font-weight: bold;
      font-family: 'Roboto Slab', serif;
    }

    > .description {
      @apply pb-4 px-4;
      @apply text-sm;
      @apply text-center;
    }

    > .actions {
      @apply text-center;
      @apply mt-4;
      > .btn {
        @apply mx-1;
      }
    }
  }
</style>
